<p-toast position="top-right"></p-toast>
<p-sidebar [(visible)]="showXpassBookingDetailSideBar"
		   [position]="'right'"
		   [baseZIndex]="10000"
		   (onHide)="cancel()"
		   [style]="{width:'854px'}">
	<ng-template pTemplate="header">
        <div class="sidebar-header-title">Booking ID: {{ transferOrderDetails?.Details?.TransferOrderId || 'Loading...' }}</div>
		<div class="sidebar-header-sub-title"></div>
	</ng-template>

	<div *ngIf="loading" style="text-align: center; padding: 30px;">
		<p-progressSpinner [style]="{width: '40px', height: '40px'}" styleClass="custom-spinner" strokeWidth="5"
						   fill="var(--surface-ground)" animationDuration="1s"></p-progressSpinner>
	</div>

	<div *ngIf="!loading">
		<p-tabMenu [model]="menuItems" [activeItem]="menuItems[0]"></p-tabMenu>

		<p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 230px)'}"
					   [styleClass]="'app-scrollpanel'">
			<div *ngIf="activeMenuTab === menuTab.TNXNDetails">
				<div class="pft-title">Booking Info</div>

				<div class="flex flex-row flex-wrap bor1">
					<div class="pft-column-50">
						<div class="flex flex-row flex-wrap mt-3">
							<div class="pft-column-50 p-3 pft-label">
								Booking ID
							</div>
							<div class="pft-column-50 p-3">
								<span class="pft-value">{{ transaction?.TransferOrderId }}</span>
								<img class="mL48" src="../Content/xpress-app/images/svg/copyclip.svg" />
							</div>
							<div class="pft-column-50 p-3 pft-label">
								Xpass Location
							</div>
							<div class="pft-column-50 p-3">
								<span class="pft-value"> {{ transaction?.Location }}</span>
							</div>
							<div class="pft-column-50 p-3 pft-label">
								Xpass Product
							</div>
							<div class="pft-column-50 p-3">
								<span class="pft-value">Stress Free</span>
							</div>
							<div class="pft-column-50 p-3 pft-label">
								Status
							</div>
							<div class="pft-column-50 p-3 confirmbtn">
								<span class="pft-value">{{ transaction?.Status }}</span>
							</div>
                        <div class="pft-column-50 p-3 pft-label" *ngIf="transferOrderDetails?.Details?.AdminActionTimestamp">
                            Admin Action<br/>Timestamp
                        </div>
                        <div class="pft-column-50 p-3" *ngIf="transferOrderDetails?.Details?.AdminActionTimestamp">
                            <span class="pft-value">{{ transferOrderDetails?.Details?.AdminActionTimestamp | date:'MMM dd, yyyy h:mm a' }}</span>
                        </div>
                        <div class="pft-column-50 p-3 pft-label" *ngIf="transferOrderDetails?.Details?.AdminActionedBy">
                            Actioned By
                        </div>
                        <div class="pft-column-50 p-3" *ngIf="transferOrderDetails?.Details?.AdminActionedBy">
                            <span class="pft-value">{{ transferOrderDetails?.Details?.AdminActionedBy }}</span>
                        </div>
							<div class="pft-column-50 p-3 pft-label">
								Pickup
							</div>
							<div class="pft-column-50 p-3">
								<span class="pft-value">{{ transaction?.PickupLocation }}</span>
							</div>
							<div class="pft-column-50 p-3 pft-label">
								Drop Off
							</div>
							<div class="pft-column-50 p-3">
								<span class="pft-value">{{ transaction?.DropOffLocation }}</span>
							</div>
							<div class="pft-column-50 p-3 pft-label">
								Payment
							</div>
							<div class="pft-column-50 p-3">
								<span class="pft-value">{{ transferOrderDetails?.Details?.PaymentType || 'None' }}</span>
							</div>
							<div class="pft-column-50 p-3 pft-label">Location</div>
							<div class="pft-column-50 p-3">
								<span class="pft-value">{{ transaction?.Location }}</span>
							</div>
						</div>
					</div>

					<div class="pft-column-50">
						<div class="flex flex-row flex-wrap mt-3">
							<div class="pft-column-50 p-3 pft-label">
								Trip
							</div>
							<div class="pft-column-50 p-3">
								<span class="pft-value">{{ tripDetail.tripType }}</span>
							</div>

							<div class="pft-column-50 p-3 pft-label">
								Trip Type
							</div>
							<div class="pft-column-50 p-3">
								<span class="pft-value">{{ tripDetail.tripDirection }}</span>
							</div>
							<div class="pft-column-50 p-3 pft-label">
								Guests
							</div>
							<div class="pft-column-50 p-3">
								<span class="pft-value">{{ tripDetail.guestCount }}</span>
							</div>
						</div>
					</div>
				</div>

				<div class="pft-title">IPass Numbers</div>
				<div class="flex flex-row flex-wrap bor1" *ngIf="!transferOrderDetails?.PassengerQrCodes?.length">
					<div class="pft-column-100 p-3">
						<span class="pft-value">No iPass Code Generated</span>
					</div>
				</div>
				<div class="flex flex-row flex-wrap bor1" *ngIf="transferOrderDetails?.PassengerQrCodes?.length">
					<ng-container *ngFor="let passenger of transferOrderDetails?.PassengerQrCodes; let last = last; let i = index">
						<div class="pft-column-100">
							<div class="flex flex-row flex-wrap mt-3">
								<div class="pft-column-50 p-3 pft-label">
									Passenger
								</div>
								<div class="pft-column-50 p-3">
									<span class="pft-value">{{ passenger.FirstName }} {{ passenger.LastName }}</span>
								</div>
								<div class="pft-column-50 p-3 pft-label">
									IPass Number
								</div>
								<div class="pft-column-50 p-3">
									<div class="ipass-copy-row">
										<span class="pft-value">{{ passenger.IPassNumber }}</span>
										<button type="button"
												class="copy-clip-btn"
												[class.copy-clip-btn--copied]="isIPassCopied(i)"
												(click)="copyIPassNumber(passenger.IPassNumber, i)"
												[title]="isIPassCopied(i) ? 'Copied!' : 'Copy IPass number'"
												[attr.aria-label]="isIPassCopied(i) ? 'Copied' : 'Copy IPass number'">
											<img *ngIf="!isIPassCopied(i)"
												 src="../Content/xpress-app/images/svg/copyclip.svg"
												 alt="" />
											<span *ngIf="isIPassCopied(i)" class="copy-clip-btn__label">Copied</span>
										</button>
									</div>
								</div>
							</div>
						</div>
						<hr *ngIf="!last" class="pft-column-100 passenger-qr-divider" />
					</ng-container>
				</div>

				<div class="pft-title">Booking Schedule</div>
				<div class="flex flex-row flex-wrap bor1">
					<div class="pft-column-100">
						<div class="flex flex-row flex-wrap mt-3">
							<div class="pft-column-50 p-3 pft-label">
								Arrival Date
							</div>
							<div class="pft-column-50 p-3">
								<span class="pft-value">{{ bookingScheduleDetail.arrivalDate }}</span>
							</div>
							<div class="pft-column-50 p-3 pft-label">
								Arrival Time
							</div>
							<div class="pft-column-50 p-3">
								<span class="pft-value">{{ bookingScheduleDetail.arrivalTime }}</span>
							</div>
							<div class="pft-column-50 p-3 pft-label">
								Modified Schedule
							</div>
							<div class="pft-column-50 p-3">
								<span class="pft-value">{{ bookingScheduleDetail.modifiedSchedule }}</span>
							</div>
						</div>
					</div>
				</div>
				<div class="pft-title">Notes</div>
				<textarea rows="5" cols="105" pTextarea [ngModel]="transferOrderDetails?.Details?.Notes" disabled
						  class="pft-value add-note-area bor1p" style="resize: none; width: 100%"></textarea>
				<div class="flex flex-row flex-wrap">
					<div class="pft-column-100">
						<div class="flex flex-row flex-wrap mt-3 mb-1 ml25 justify-content-around">
							<button pButton class="btn-add-notes btn-discard-alt" style="width: 125px"
									(click)="openCancelTripDialog()">Cancel Trip
							</button>
							<button pButton class="btn-add-notes btn-secondary" (click)="openAddNotes()">Add Notes
							</button>
							<button pButton class="btn-reassign-driver btn-default" (click)="openReassignDriver()">
								Reassign Driver
							</button>
							<button [disabled]="transferOrderDetails?.Details?.IpassValid || regeneratingQrCode"
									[loading]="regeneratingQrCode"
									pButton
									class="btn-default"
									(click)="regenerateQrCode(transferOrderDetails?.Details?.TransferOrderId!)">
								<span *ngIf="!regeneratingQrCode">Regenerate QR Code</span>
								<span *ngIf="regeneratingQrCode">Regenerating...</span>
							</button>
						</div>
					</div>
				</div>
			</div>
			<div *ngIf="activeMenuTab === menuTab.Customer">
				<div class="flex flex-row flex-wrap bor1 customer">
					<div class="pft-column-100">
						<div class="pft-column-100">
							<div class="flex flex-row flex-wrap mt-3">
								<div class="w20p">
									<img class="text-center rounded-full padProfile"
										 src="/Content/xpress-app/images/avatar/avatarDrive.png"/>
								</div>
								<div class="w80p">
									<div class="flex flex-row p-3 items-center">
										<div class="w60p pft-label">Name:</div>
										<div class="w40p pft-value textline">{{ customerDetail.name }}</div>
									</div>

									<div class="flex flex-row p-3 items-center">
										<div class="w60p pft-label">Sign up:</div>
										<div class="w40p pft-value">{{ customerDetail.signupDate }}<span
												*ngIf="customerDetail.signupDaysAgo"> ({{ customerDetail.signupDaysAgo }}
											days)</span></div>
									</div>

									<div class="flex flex-row p-3 items-center">
										<div class="w60p pft-label">Phone:</div>
										<div class="dmp40 w40p pft-value">{{ customerDetail.phone }}
											<div class="vgreen" *ngIf="customerDetail.phoneVerified">verified</div>
										</div>
									</div>

									<div class="flex flex-row p-3 items-center">
										<div class="w60p pft-label">Rating:</div>
										<div class="w40p pft-value">{{ customerDetail.rating }}</div>
									</div>

									<div class="flex flex-row p-3 items-center">
										<div class="w60p pft-label">Account:</div>
										<div class="w40p pft-value textline">{{ customerDetail.account }}</div>
									</div>

									<div class="flex flex-row p-3 items-center">
										<div class="w60p pft-label">Application:</div>
										<div class="w40p pft-value">{{ customerDetail.application }}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="flex flex-row flex-wrap bor1">
					<div class="pft-column-100">
						<div class="flex flex-row flex-wrap mt-3">
							<div class="pft-column-50 p-3 pft-label">
								Bookings
							</div>
							<div class="pft-column-50 p-3">
								<span class="pft-value">12 Jan 2023 (42 days)</span>
							</div>
							<div class="pft-column-50 p-3 pft-label">
								Completed:
							</div>
							<div class="pft-column-50 p-3">
								<span class="pft-value">1,234 (100%)</span>
							</div>
							<div class="pft-column-50 p-3 pft-label">
								Spend:
							</div>
							<div class="pft-column-50 p-3">
								<span class="pft-value">₱100,000.00</span>
							</div>
							<div class="pft-column-50 p-3 pft-label">
								Priority:
							</div>
							<div class="pft-column-50 p-3">
								<span class="pft-value">VIP</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div *ngIf="activeMenuTab === menuTab.Driver">
				<div class="flex flex-row flex-wrap mt-3" *ngIf="driverDetail.name === 'Not Assigned'">
					<div class="w80p">
						<div class="flex flex-row p-3 items-center">
							<img
									src="../Content/xpress-app/images/nodriverAssigned.png"
									alt="xpass-logo"
									class="nodriver"
							/>
						</div>
					</div>
				</div>
				<div class="flex flex-row flex-wrap bor1 driver" *ngIf="driverDetail.name !== 'Not Assigned'">
					<div class="pft-column-100">
						<div class="pft-column-100">
							<div class="flex flex-row flex-wrap mt-3">
								<div class="w20p">
									<img class="text-center rounded-full padProfile"
										 src="/Content/xpress-app/images/avatar/avatarDrive.png"/>
								</div>
								<div class="w80p">
									<div class="flex flex-row p-3 items-center">
										<div class="w60p pft-label">Name:</div>
										<div class="w40p pft-value">{{ driverDetail.name }}</div>
									</div>

									<div class="flex flex-row p-3 items-center">
										<div class="w60p pft-label">Sex:</div>
										<div class="w40p pft-value">{{ driverDetail.sex }}</div>
									</div>

									<div class="flex flex-row p-3 items-center">
										<div class="w60p pft-label">Phone:</div>
										<div class="w40p pft-value">{{ driverDetail.phone }}</div>
									</div>

									<div class="flex flex-row p-3 items-center">
										<div class="w60p pft-label">Email:</div>
										<div class="w40p pft-value">{{ driverDetail.email }}</div>
									</div>

									<div class="flex flex-row p-3 items-center">
										<div class="w60p pft-label">Date of Birth:</div>
										<div class="w40p pft-value">{{ driverDetail.dateOfBirth }}</div>
									</div>

									<div class="flex flex-row p-3 items-center">
										<div class="w60p pft-label">Full Profile:</div>
										<div class="w40p pft-value viewprofile">View</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div *ngIf="activeMenuTab === menuTab.Payment">
				<div class="flex flex-row flex-wrap">
					<div class="pft-column-100">
						<div class="pft-title">Xpress Transaction</div>
						<div class="flex flex-row flex-wrap mt-3">
							<div class="pft-column-25 p-3 pft-label">Transaction Date:</div>
							<div class="pft-column-25 p-3 txtright">
								<span class="pft-value">{{ paymentDetail.transactionDate }}</span>
							</div>
							<div class="pft-column-25 p-3 pft-label">Transaction time:</div>
							<div class="pft-column-25 p-3 txtright">
								<span class="pft-value">{{ paymentDetail.transactionTime }}</span>
							</div>
							<div class="pft-column-25 p-3 pft-label">Transaction Type:</div>
							<div class="pft-column-25 p-3 txtright">
								<span class="pft-value">{{ paymentDetail.transactionType }}</span>
							</div>
						</div>

						<div class="pft-title">Payment</div>
						<div class="flex flex-row flex-wrap mt-3">
							<div class="pft-column-25 p-3 pft-label">Payment method:</div>
							<div class="pft-column-25 p-3 text-end">
								<span class="pft-value">{{ paymentDetail.paymentMethod }}</span>
							</div>

							<div class="pft-column-25 p-3 pft-label">Partner TX ID:</div>
							<div class="pft-column-25 p-3 text-end">
								<span class="pft-value">{{ paymentDetail.partnerTransactionId }}</span>
							</div>

							<div class="pft-column-25 p-3 pft-label">Transaction amount:</div>
							<div class="pft-column-25 p-3 text-end">
								<span class="pft-value">{{ paymentDetail.transactionAmount }}</span>
							</div>

							<div class="pft-column-25 p-3 pft-label">Transaction Status:</div>
							<div class="pft-column-25 p-3 text-end">
								<span class="pft-value">{{ paymentDetail.transactionStatus }}</span>
							</div>
							<div class="pft-column-50 p-3 pft-label">Total Paid:</div>
							<div class="pft-column-50 p-3">
								<span class="pft-value">{{ paymentDetail.totalPaid }}</span>
							</div>
							<div class="pft-column-50 p-3 pft-label">Tricycle Transfer:</div>
							<div class="pft-column-50 p-3">
								<span class="pft-value">{{ paymentDetail.tricycleTransfer }}</span>
							</div>
							<div class="pft-column-50 p-3 pft-label">Terminal Fee:</div>
							<div class="pft-column-50 p-3">
								<span class="pft-value">{{ paymentDetail.terminalFee }}</span>
							</div>
							<div class="pft-column-50 p-3 pft-label">Boat Transfer:</div>
							<div class="pft-column-50 p-3">
								<span class="pft-value">{{ paymentDetail.boatTransfer }}</span>
							</div>
							<div class="pft-column-50 p-3 pft-label">Etrike Transfer:</div>
							<div class="pft-column-50 p-3">
								<span class="pft-value">{{ paymentDetail.etrikeTransfer }}</span>
							</div>
							<div class="pft-column-50 p-3 pft-label">Environmental fee:</div>
							<div class="pft-column-50 p-3">
								<span class="pft-value">{{ paymentDetail.environmentalFee }}</span>
							</div>
							<div class="pft-column-50 p-3 pft-label">Promo:</div>
							<div class="pft-column-50 p-3">
								<span class="pft-value">{{ paymentDetail.promo }}</span>
							</div>
							<div class="pft-column-50 p-3 pft-label">Amount Paid:</div>
							<div class="pft-column-50 p-3">
								<span class="pft-value">{{ paymentDetail.amountPaid }}</span>
							</div>
							<div class="pft-column-50 p-3 pft-label">Convenience fee</div>
							<div class="pft-column-50 p-3">
								<span class="pft-value">{{ paymentDetail.convenienceFee }}</span>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div *ngIf="activeMenuTab === menuTab.Timeline">
				<div class="pft-title">Order Timeline</div>
				<div class="flex flex-row flex-wrap">
					<div class="pft-column-20">
						<div class="flex flex-row flex-wrap mt-3">
							<div class="pft-column-50 p-1 pft-label">
								Priority:
							</div>
							<div class="pft-column-50 p-1 text-end">
								<span class="pft-value vip">{{ orderTimelineInfo.priority }}</span>
							</div>
							<div class="pft-column-50 p-1 pft-label">
								Session Time:
							</div>
							<div class="pft-column-50 p-1 text-end">
								<span class="pft-value">{{ orderTimelineInfo.sessionTime }}</span>
							</div>
						</div>
					</div>
					<div class="pft-column-80">
						<div class="flex flex-row flex-wrap mt-3 justify-content-start">
							<div class="w-100 text-start top-86">
								<p-timeline [value]="events" layout="vertical">
									<ng-template pTemplate="content" let-event>
										<div class="timeline-content">
											<div class="eventstatus">
												<div>
													<p>{{ event.detail }}</p>
												</div>
												<div>
													- {{ event.dateTime }}
												</div>
											</div>
										</div>
									</ng-template>
									<ng-template pTemplate="marker" let-event>
                                <span
										[ngClass]="{
                                    'custom-marker': true,
                                    'done-marker': event.status === 'Done',
                                    'pending-marker': event.status !== 'Done'
                                    }"
								>
                                    <i *ngIf="event.status === 'Done'" class="pi pi-check fs-8px"></i>
                                </span>
									</ng-template>
								</p-timeline>
							</div>
						</div>
					</div>
				</div>
				<!-- google map here -->
				<div *ngIf="activeMenuTab === menuTab.Timeline">
					<div #mapContainer id="map" style="height: 400px;"></div>
				</div>
				<div class="route-summary">
					<span class="ml48">Pick up</span>
					<div class="route-point">
						<img
								src="XpressApp\assets\images\live-map-icons\pickup.svg"
								alt="xpass-logo"
								class="py-3 w33"
						/>
						<span class="route-label">{{ transaction?.PickupLocation }}</span>
					</div>
					<div class="route-line">
						<span class="route-dots"></span>
					</div>
					<span class="ml48">Destination</span>
					<div class="route-point">
						<img
								src="XpressApp\assets\images\live-map-icons\destination.svg"
								alt="xpass-logo"
								class="py-3 w30"
						/>
						<span class="route-label">{{ transaction?.DropOffLocation }}</span>
					</div>
				</div>
			</div>
		</p-scrollPanel>
	</div>

</p-sidebar>
<p-dialog header="Cancel Trip?" [(visible)]="showCancelTripDialog" [modal]="true" [closable]="false"
		  [style]="{width: '650px'}">
	<div>Are you sure you want to cancel tris trip? This action cannot be undone.</div>
	<div class="p-dialog-footer" style="margin-top: 2em; text-align: right;">
		<button pButton type="button" label="Go Back" class="p-button-text btngo"
				(click)="closeCancelTripDialog()"></button>
		<button pButton type="button" label="Yes, Cancel Trip" class="p-button-danger btncancel"
				(click)="confirmCancelTrip()"></button>
	</div>
</p-dialog>

<p-dialog
		[modal]="true"
		[closable]="false"
		[draggable]="false"
		[resizable]="false"
		[(visible)]="showAddNotes"
		[style]="{ width: '700px', height: '300px' }">
	<ng-template pTemplate="header">
		<span class="add-note-header">{{noteHeader}}</span>
	</ng-template>
	<ng-template pTemplate="body">
		<div class="mb-3 note-header">Note</div>
		<textarea class="add-note-area" [(ngModel)]="transferNote" placeholder="Enter your note here..."></textarea>

		<div class="mt-4 flex justify-content-end">
			<button pButton class="btn-cancel-add-note btn-secondary" (click)="cancelAddNotes()">Cancel</button>
			<button pButton class="btn-add-note btn-default ml-3" [ngClass]="{'btn-disabled': !transferNote}"
					[disabled]="!transferNote" (click)="addTransferNote()">Add Note
			</button>
		</div>
	</ng-template>
</p-dialog>
